module.exports = __webpack_public_path__ + "img/conteesa.25d86d52.png";